import { FileTextOutlined } from '@ant-design/icons';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { type RichiestaModuloDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTO.ts';
import { mapSubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/mapSubmissionModuleState.ts';
import { ModuleValidationStateIconBadge } from '@framework/frontoffice-submission/module/form/title/ModuleValidationStateIconBadge.tsx';
import { getModuleTitle } from '@framework/frontoffice-submission/module/getModuleTitle.ts';
import { DownloadSubmissionModuleButton } from '@framework/frontoffice-submission/submission/download-pdf/DownloadSubmissionModuleButton.tsx';
import { SubmissionLogic } from '@framework/frontoffice-submission/submission/SubmissionLogic.ts';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Space } from 'antd';
import {
  ElementSummaryWrapper,
  ElementTitle,
} from './SubmissionSummary.styles.tsx';

interface SubmissionSummaryModuleProps {
  submission: RichiestaDTO | null | undefined;
  module: RichiestaModuloDTO;
  /** Se c'è più di un modulo, mostriamo il tasto di download per ogni modulo */
  hasInlineDownload?: boolean;
}

/**
 * Riga di dettaglio per il riepilogo di un modulo in una richiesta.
 * Ne viene mostrato il titolo e lo stato di validazione, più un pulsante
 * per permettere il download del PDF del modulo.
 */
export function SubmissionModuleSummary({
  module,
  submission,
  hasInlineDownload,
}: SubmissionSummaryModuleProps) {
  return (
    <ElementSummaryWrapper>
      {/* //TODO: Aggiungere componente aggiornato per comportamento mobile */}
      <FlexRow
        style={{ width: '100%' }}
        gutter={12}
        right={
          <Space>
            {hasInlineDownload && (
              <DownloadSubmissionModuleButton
                submissionModuleId={module.id}
                submissionId={submission?.id}
                isModuleSigned={module.idFileFirmato != null}
                inline
                disabled={
                  SubmissionLogic.isSubmissionNew(submission) ||
                  !module.statoValidazione?.visitato
                }
              />
            )}
            <ModuleValidationStateIconBadge
              validationState={module.statoValidazione}
              type={mapSubmissionModuleState(module.statoCompilazione)}
            />
          </Space>
        }
      >
        <ElementTitle>
          <FlexRow
            gutter={8}
            align="flex-start"
            left={<FileTextOutlined aria-hidden />}
          >
            {getModuleTitle(module)}
          </FlexRow>
        </ElementTitle>
      </FlexRow>
    </ElementSummaryWrapper>
  );
}
